/**
 * Beauty Salons - Services Page
 * Manage beauty salon services catalog
 */

import { useEffect } from 'react';
import { AllServicesPage } from '@/components/industry/pages/AllServicesPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function BeautySalonsServicesPage() {
  useEffect(() => {
    document.title = 'Serviços | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <AllServicesPage
      domain={CompanyType.BEAUTY_SALONS}
      pageTitle="Serviços do Salão"
      pageDescription="Gerencie o catálogo de serviços de beleza oferecidos"
    />
  
    </MainLayout>);
}

